<div class="relative inline-block">
  <!-- Input display button -->
  <button
    type="button"
    class="px-3 py-1 border rounded-[2px] bg-white text-left w-64"
    (click)="show.set(!show())"
  >
    <ng-container *ngIf="isDateRangeSelection()">
      <span class="text-gray-500 text-base">{{ (_value.start?.toLocaleDateString() ?? '') | translate }}</span>
      <span class="font-bold text-black text-lg mx-4">→</span>
      <span class="text-gray-500 text-base">{{ (_value.end?.toLocaleDateString() ?? '') | translate }}</span>
    </ng-container>
        <ng-container *ngIf="isStartDateOnlySelection()">
          <span class="text-gray-500 text-base">{{ (_value.start?.toLocaleDateString() ?? '') | translate }}</span>
          <span class="font-bold text-black text-2xl mx-4">→</span>
          <span class="text-gray-500 text-base">...</span>
        </ng-container>
    <ng-container *ngIf="isNoDateSelection()">
      <span>{{ 'select-range-date' | translate }}</span>
    </ng-container>
  </button>

  <!-- Popup Calendar -->
  <div
    *ngIf="show()"
    class="absolute z-20 mt-2 p-4 bg-white border rounded-lg shadow-xl w-80"
  >
    <!-- Header: Month and Year Navigation -->
    <div class="flex justify-between items-center mb-3">
      <button type="button" class="p-1" (click)="prevMonth()">←</button>
      <div class="font-semibold">
        {{ monthName | translate }} - {{ currentMonthAndYear() | date:'yyyy' }}
      </div>
      <button type="button" class="p-1" (click)="nextMonth()">→</button>
    </div>

    <!-- Calendar grid -->
    <div class="grid grid-cols-7 gap-0 text-center text-sm">
      <div class="font-medium text-gray-500">{{'components.calendar.abbrev-monday' | translate }}</div>
      <div class="font-medium text-gray-500">{{'components.calendar.abbrev-tuesday' | translate }}</div>
      <div class="font-medium text-gray-500">{{'components.calendar.abbrev-wednesday' | translate }}</div>
      <div class="font-medium text-gray-500">{{'components.calendar.abbrev-thursday' | translate }}</div>
      <div class="font-medium text-gray-500">{{'components.calendar.abbrev-friday' | translate }}</div>
      <div class="font-medium text-gray-500">{{'components.calendar.abbrev-saturday' | translate }}</div>
      <div class="font-medium text-gray-500">{{'components.calendar.abbrev-sunday' | translate }}</div>

      <ng-container *ngFor="let day of calendar">
        <button
          type="button"
          *ngIf="day; else blank"
          class="py-2 ml-0"
          [class.bg-blue-700]="isStartDate(day) || isEndDate(day)"
          [class.rounded-md]="isStartDate(day) || isEndDate(day)"
          [class.text-white]="isStartDate(day) || isEndDate(day)"
          [class.font-bold]="isStartDate(day) || isEndDate(day)"
          [class.bg-blue-200]="isBetweenSelectedRange(day)"
          [class.my-1]="isBetweenSelectedRange(day)"
          [class.text-gray-700]="isBetweenSelectedRange(day)"
          [class.font-normal]="isBetweenSelectedRange(day)"
          [class.hover:bg-blue-100]="!isSelected(day)"
          [class.hover:bg-orange-300]="isSelected(day)"
          (click)="select(day)"
        >
          {{ day }}
        </button>

        <ng-template #blank>
          <div></div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
